import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';

import style from './styles.module.less';

export const EditRecipientTaxIdentifiersInstructions = () => (
  <Text className={style.instructions} textType={TextType.Paragraph} value={messages.recipientTaxIdentifierInstructions} />
);
